import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en.json';
import translationDE from './locales/de.json';

const resources = {
  en: {
    translation: translationEN
  },
  de: {
    translation: translationDE
  }
};

// German-first site: German is the default; English only when the browser
// actually requests it (navigator), or when the visitor explicitly picked it
// (LanguageSwitcher -> cached under 'amt_i18n_lng').
// Key is versioned ('amt_i18n_lng', not i18next's default 'i18nextLng') so
// stale 'en' values cached by earlier deploys cannot override detection.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    supportedLngs: ['en', 'de'],
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'amt_i18n_lng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
